import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0488f328&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0488f328&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=0488f328&prod&lang=scss&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&id=0488f328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488f328",
  null
  
)

export default component.exports